<template>
  <profile-section
    section-title="Customer Success"
  >
    <div class="profile-list-section">
      <router-link
        :to="supportRoute"
        class="customer-success-link"
      >
        Contact Us
      </router-link>
      <a
        href="https://hltcorp.zendesk.com/hc/en-us"
        target="_blank"
        rel="noopener norefer"
        class="customer-success-link"
      >
        FAQ
      </a>
    </div>
  </profile-section>
</template>

<script>
import ProfileSection from '@components/profile/section';

export default {
  components: {
    ProfileSection,
  },
  computed: {
    supportRoute() {
      return {
        name: 'support',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-list-section {
  margin-left: auto;

  .customer-success-link {
    color: #00d8f8;
    padding: 0;
    border-bottom: 1px solid transparent;
    background: transparent;
    display: block;
    margin-left: auto;
    text-align: right;
    font-weight: normal;

    &:not(:first-of-type) {
      margin-top: rem-calc(20);
    }

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
